import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import jwt from 'jsonwebtoken'

const verifyTokenSchema = z.object({
  token: z.string().min(1),
})

interface TokenPayload {
  username: string
  iat: number
}

export const verifyToken = createServerFn({ method: 'POST' })
  .inputValidator(verifyTokenSchema)
  .handler((ctx): { valid: boolean; username: string } => {
    const { token } = ctx.data

    const JWT_SECRET =
      process.env.JWT_SECRET || 'your-secret-key-change-in-production'

    try {
      const decoded = jwt.verify(token, JWT_SECRET) as TokenPayload

      return {
        valid: true,
        username: decoded.username,
      }
    } catch (error) {
      throw new Error('Invalid or expired token')
    }
  })
